import { calculateUserPresence } from '@dxp/core/helpers';
import { IScope } from '../agent/agent-scope';
import { IPresence } from '../presence/presence';
import { IRbacTenant, IRbacUserTenant } from '../rbac/tenant';
import { IRbacUser } from '../rbac/user';

export interface IUser extends IRbacUser {
    authenticated: boolean;
    photo?: string;
    tenant?: IRbacTenant;
    tenants: IRbacUserTenant[];
    scopes: IScope[];
    presence: IPresence;
    businessUnits: string[];
    canChangeState: boolean;
}

export const DefaultTelXLUser: IUser = {
    id: '',
    name: '',
    emailAddress: '',
    authenticated: false,
    enabled: false,
    phoneNumber: '',
    profilePictureUrl: null,
    photo: undefined,
    tenantId: '',
    displayName: '',
    jobTitle: '',
    tenants: [],
    tenant: undefined,
    scopes: [] as IScope[],
    presence: calculateUserPresence('LoggedOut', new Date(), ''),
    businessUnits: [],
    canChangeState: true,
};
